import { render, staticRenderFns } from "./view_account_link.vue?vue&type=template&id=2c9278c1&scoped=true&"
import script from "./view_account_link.vue?vue&type=script&lang=js&"
export * from "./view_account_link.vue?vue&type=script&lang=js&"
import style0 from "./view_account_link.vue?vue&type=style&index=0&id=2c9278c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9278c1",
  null
  
)

export default component.exports